/**
 * Função principal para o fluxo de filtrar, organizar e exportar os usuários em cada arquivo
 */
export const exportUsers = (originalUsers) => {
  const filteredUsers = filterUsers(originalUsers);
  const sortedUsers = organizeUsers(filteredUsers);
  convertToCSV(sortedUsers);
};

/**
 * Função auxiliar para filtrar os usuários de acordo com as regras estipuladas
 * @param {Array} users - Lista de todos os usuários
 * @returns {Object} - Objeto contendo array de usuários filtrados de acordo com o locale
 */
const filterUsers = (users) => {
  const acceptedRoles = ["CUSTOMER", "AGENT"];
  const ignoredIDs = [1, 2, 5, 6, 9, 25, 26, 46, 72, 97, 361];

  users = users.filter((user) => acceptedRoles.includes(user.role));
  users = users.filter((user) => !ignoredIDs.includes(user.id));
  users = users.filter((user) => user.emailConfirmed);
  users = users.map((user) => {
    return {
      name: user.name,
      email: user.email,
      role: user.role,
      locale: user.locale,
    };
  });

  const filteredUsers = {
    br: users.filter((user) => user.locale === "br"),
    es: users.filter((user) => user.locale === "es"),
    en: users.filter((user) => user.locale === "en"),
  };

  return filteredUsers;
};

/**
 * Função auxiliar para organizar as listas de usuários dentro do objeto, primeiro por agentes em ordem alfabética e depois por clientes em ordem alfabética
 * @param {Object} users - Objeto com usuários filtrados de acordo com o locale
 * @returns {Object} - Objeto com listas de usuários organizados por agente em ordem alfabética e clientes em ordem alfabética
 */
const organizeUsers = (users) => {
  const sortedUsers = {
    br: sortArray(users.br),
    es: sortArray(users.es),
    en: sortArray(users.en),
  };
  return sortedUsers;
};

/**
 * Função auxiliar para ordenar a lista de usuários
 * @param {Array} users - Lista de usuários
 * @returns {Array} - Lista de usuários ordenada por agente em ordem alfabética e depois clientes em ordem alfabética
 */
const sortArray = (users) => {
  const agents = users.filter((user) => user.role === "AGENT");
  const customers = users.filter((user) => user.role === "CUSTOMER");
  agents.sort((a, b) => a.name.localeCompare(b.name));
  customers.sort((a, b) => a.name.localeCompare(b.name));
  return [...agents, ...customers];
};

/**
 * Função para converter o objeto de usuários em CSV e fazer o download
 * @param {Object} users - Objeto de usuários organizados por locale
 * @returns {void}
 */
const convertToCSV = (users) => {
  const today = new Date();
  const formattedDate = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, "0")}-${String(today.getDate()).padStart(2, "0")}`;
  for (let locale in users) {
    let csv = `"Nome","E-mail","tipo"\n`;

    users[locale].forEach((user, index) => {
      let row = `"${user.name}","${user.email}","${user.role}"`;
      if (index < users[locale].length - 1) row += "\n";
      csv += row;
    });

    const blob = new Blob([csv], { type: "text/csv" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `LC_lista_usuários_${formattedDate}_${locale.toUpperCase()}.csv`;
    a.click();
    URL.revokeObjectURL(url);
  }
};
